import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import StudentAccess from '@3plearning/student-restrict-access';
import upfTheme from '@themes/index';
import Resources from '@helpers/resources';
import { getLocale } from '@helpers/locale';
import { getConfiguration } from '@helpers/utils';

const StudentOnTaskLock = ({ i18n }) => {
  const localeCdnBaseUrl = getConfiguration('localeCdnBaseUrl');

  const activeClass = useSelector(state => state.UPFAssignReducer?.selectedClass?.value);

  const activeGroup = useSelector(state => state.UPFAssignReducer?.selectedGroup?.value);

  return (
    localeCdnBaseUrl !== '' &&
    activeClass &&
    activeGroup && (
      <StudentAccess
        classId={activeClass}
        groupId={activeGroup}
        i18n={i18n}
        locale={getLocale()}
        localeCdnBaseUrl={localeCdnBaseUrl}
        Resources={Resources}
        theme={upfTheme}
      />
    )
  );
};

StudentOnTaskLock.propTypes = {
  i18n: PropTypes.object
};

export default StudentOnTaskLock;



// WEBPACK FOOTER //
// ./components/student-access/student-access.js